import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("harmonix_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const profileId = localStorage.getItem("harmonix_profile_id");
  if (profileId) {
    config.headers["X-Profile-Id"] = profileId;
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.message === "string") return detail.message;
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function isUpgradeRequired(err) {
  return err?.response?.status === 402 && err?.response?.data?.detail?.code === "upgrade_required";
}

export default api;
